import { Close } from '@mui/icons-material';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  IconButton,
} from '@mui/material';
import React from 'react';
import { useForm } from 'react-hook-form';
import { useAnalyzeInterview, useAnalyzeSurvey } from '../../../hooks/postQueries';

function SurveyAnalysis({ rowId, openDialog, handleCloseDialog, isInterview }) {
  const { handleSubmit } = useForm();

  const { mutateAsync } = useAnalyzeSurvey(rowId);
  const { mutate: analyzeInterview } = useAnalyzeInterview();

  const handleCloseAnalysis = () => {
    handleCloseDialog();
  };

  const onSubmit = () => {
    isInterview
      ? analyzeInterview(rowId)
      : mutateAsync(rowId, {
          onSuccess: () => {
            setTimeout(() => {
              handleCloseAnalysis();
            }, 2000);
          },
          onError: (err) => {
            if (err?.detail) {
              handleCloseAnalysis();
            }
          },
        });
  };

  return (
    <React.Fragment>
      <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md">
        <DialogTitle
          fontWeight={600}
          display={'flex'}
          justifyContent={'space-between'}
          alignItems={'center'}
          id="alert-dialog-title"
        >
          <span>Analyze Survey?</span>
          <IconButton size="small" onClick={handleCloseDialog}>
            <Close style={{ width: 20, height: 20 }} cursor="pointer" />
          </IconButton>
        </DialogTitle>
        <Divider />
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <DialogContentText>
              Clicking &apos;Yes&apos; will start the analysis process.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button variant="default" onClick={handleCloseDialog}>
              Cancel
            </Button>
            <Button variant="contained" type="submit">
              Confirm
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </React.Fragment>
  );
}

export default SurveyAnalysis;
